import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Button } from "components/Button";

export const DataGridNoResults: React.FC<{ className?: string; isFilterEmpty: boolean; onFilterClear: () => void }> = ({
    className,
    isFilterEmpty,
    onFilterClear,
}) => {
    return (
        <div className={classNames("d-flex flex-column align-items-center justify-content-center text-center text-secondary", className)}>
            <FontAwesomeIcon className="p-4 border border-2 rounded-circle" icon={["fal", "magnifying-glass"]} size="2xl" />
            <p className="fs-5 pt-3">No results found</p>
            <p className="fs-6 pb-3">Try adjusting your search to find matches.</p>
            {!isFilterEmpty && (
                <Button variant="link" className="text-decoration-none" onClick={() => onFilterClear()}>
                    Clear all
                </Button>
            )}
        </div>
    );
};
